import React from "react";

const LanguageToggleButton = ({ theme, language, toggleLanguage }) => (
  <button
    style={{
      padding: "8px 12px",
      borderRadius: "12px",
      cursor: "pointer",
      color: theme === "light" ? "#0f172a" : "white",
      background: theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease",
      fontWeight: "600",
      fontSize: "14px"
    }}
    onClick={toggleLanguage}
    title={language === 'ar' ? 'Switch to English' : 'التبديل للعربية'}
  >
    {language === 'ar' ? 'EN' : 'ع'}
  </button>
);

export default LanguageToggleButton;
